import type { PrivateEventDetail } from '../../api/privateEvents';
import { useViewport } from '../../hooks/useViewport';

import ImportedFromFareharborBanner from './ImportedFromFareharborBanner';
import PrivateEventCrewSection from './PrivateEventCrewSection';
import PrivateEventDetailsCard from './PrivateEventDetailsCard';
import { missingImportFields } from './privateEventDisplay';
import PrivateEventHistoryCard from './PrivateEventHistoryCard';

/**
 * PrivateEventDetailBody — the loaded detail page's two-column layout. The
 * details card is the left column; crew and the change history stack in the right
 * column at desktop. Below desktop (tablet and phone both) the columns stack, matching the approved design brief. An
 * imported event with gaps gets one banner above both, explaining them.
 */
export default function PrivateEventDetailBody({ event }: { event: PrivateEventDetail }) {
  const { isDesktop } = useViewport();
  const missing = event.migrated ? missingImportFields(event) : [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {missing.length > 0 && <ImportedFromFareharborBanner missing={missing} />}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isDesktop ? '1.55fr 1fr' : '1fr',
          gap: 16,
          alignItems: 'start',
        }}
      >
        <PrivateEventDetailsCard event={event} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, minWidth: 0 }}>
          <PrivateEventCrewSection event={event} />
          <PrivateEventHistoryCard eventId={event.id} />
        </div>
      </div>
    </div>
  );
}
